import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { getToken, setToken, verifyPassword } from "@/lib/api";

// Wraps the app behind a shared-password gate. Stores the token in localStorage;
// the api interceptor sends it on every request and clears it on 401.
export default function LoginGate({ children }) {
  const [authed, setAuthed] = useState(() => !!getToken());
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setError("");
    try {
      const ok = await verifyPassword(password);
      if (ok) {
        setToken(password);
        setAuthed(true);
      } else {
        setError("Nieprawidłowe hasło.");
      }
    } catch {
      setError("Błąd połączenia z serwerem.");
    } finally {
      setLoading(false);
    }
  };

  if (authed) return children;

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: "#F5F3EE" }}
    >
      <Card className="w-full max-w-sm p-8 space-y-6">
        <div className="text-center space-y-1">
          <h1 className="text-2xl font-semibold" style={{ color: "#8C3F22" }}>
            Stolarnia Pro
          </h1>
          <p className="text-sm text-muted-foreground">Wpisz hasło dostępu</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="password">Hasło</Label>
            <Input
              id="password"
              type="password"
              data-testid="login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <Button
            type="submit"
            className="w-full"
            disabled={loading}
            data-testid="login-submit-button"
          >
            {loading ? "Sprawdzanie..." : "Zaloguj"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
